<template>
  <div class="error-pages">
    <div class="wrapper">
      <div class="error-pages__body">
        <h1>{{ trans.text.notFound.title }}</h1>
        <img alt="" src="/assets/images/404/error-404.jpg">
        <a class="btn btn-green" href="/">{{ trans.text.notFound.backBtn }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pageNotFound",
  props: ['lang', 'trans'],
}
</script>

